module.exports = __webpack_public_path__ + "static/img/2.65d28ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/eng/2.png
// module id = 1Ge7
// module chunks = 0